import React from "react";
import PropTypes from "prop-types";
import {
    Button,
    Slider,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography
} from "@mui/material";
import {
    CloudDownload,
    CloudUpload,
    DeleteForever,
    FormatAlignLeft,
    FormatAlignRight,
    Print
} from '@mui/icons-material';
import {
    max_height,
    max_increase,
    max_repeats,
    max_size
} from "../App";

PatternControls.propTypes = {
    size: PropTypes.number,
    onSizeChange: PropTypes.func,
    increase: PropTypes.number,
    onIncreaseChange: PropTypes.func,
    height: PropTypes.number,
    onHeightChange: PropTypes.func,
    repeats: PropTypes.number,
    onRepeatsChange: PropTypes.func,
    left: PropTypes.bool,
    onLeftChange: PropTypes.func,
    onReset: PropTypes.func,
    onPrint: PropTypes.func,
    onSave: PropTypes.func,
    onLoad: PropTypes.func,
};

function SliderControl({ id, label, value, min, max, onChange }) {
    return (
        <div className="control">
            <Typography id={id} gutterBottom>
                {label}&nbsp;{value}
            </Typography>
            <Slider
                size="small"
                style={{ width: 200 }}
                value={value}
                min={min}
                max={max}
                aria-labelledby={id}
                onChange={onChange}
            />
        </div>
    );
}

export function PatternControls(props) {
    const {
        size,
        onSizeChange,
        increase,
        onIncreaseChange,
        height,
        onHeightChange,
        repeats,
        onRepeatsChange,
        left,
        onLeftChange,
        onReset,
        onPrint,
        onSave,
        onLoad,
    } = props;

    return (
        <div className="controls">
            <SliderControl
                id="size"
                label="Größe:"
                value={size}
                min={10}
                max={max_size}
                onChange={onSizeChange}
            />
            <SliderControl
                id="increase"
                label="Zunahmen:"
                value={increase}
                min={1}
                max={max_increase}
                onChange={onIncreaseChange}
            />
            <SliderControl
                id="height"
                label="Höhe:"
                value={height}
                min={1}
                max={max_height}
                onChange={onHeightChange}
            />
            <SliderControl
                id="repeats"
                label="Wiederholungen:"
                value={repeats}
                min={1}
                max={max_repeats}
                marks
                onChange={onRepeatsChange}
            />
            <div className="control">
                <ToggleButtonGroup
                    size="small"
                    value={left}
                    exclusive
                    onChange={onLeftChange}
                    aria-label="Ausrichtung"
                >
                    <Tooltip title="Ausrichtung links" arrow>
                        <ToggleButton value={true} aria-label="left aligned">
                            <FormatAlignLeft/>
                        </ToggleButton>
                    </Tooltip>
                    <Tooltip title="Ausrichtung rechts" arrow>
                        <ToggleButton value={false} aria-label="right aligned">
                            <FormatAlignRight/>
                        </ToggleButton>
                    </Tooltip>
                </ToggleButtonGroup>
            </div>
            <div className="control">
                <Tooltip title="Muster zurücksetzen" arrow>
                    <Button variant="outlined" onClick={onReset}>
                        <DeleteForever/>
                    </Button>
                </Tooltip>
            </div>
            <div className="control">
                <Tooltip title="Drucken" arrow>
                    <Button variant="outlined" onClick={onPrint}>
                        <Print/>
                    </Button>
                </Tooltip>
            </div>
            <div className="control">
                <Tooltip title="Speichern" arrow>
                    <Button variant="outlined" onClick={onSave}>
                        <CloudUpload/>
                    </Button>
                </Tooltip>
            </div>
            <div className="control">
                <Tooltip title="Laden" arrow>
                    <Button variant="outlined" onClick={onLoad}>
                        <CloudDownload/>
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
}
